<template>
  <div class="wrapper" :class="{ expanded: value }">
    <div
      class="d-inline-flex align-items-center capsule pointer"
      :class="{ highlight: !value && highlight }"
      @click="$emit('input', !value)"
    >
      <collapse-caret class="mr-1" :expanded="value" />
      <span class="text-small-1" :class="{ bold: value }">{{ text }}</span>
    </div>
    <b-collapse class="expandable-section" v-model="value">
      <slot></slot>
    </b-collapse>
  </div>
</template>

<script>
/**
 * This gives a expandable block with a heading text.. Clicking the text collapses/expanded the block
 */
import CollapseCaret from '@/components/CollapseCaret'
import { BCollapse } from 'bootstrap-vue'

export default {
  name: 'ExpandableBlock',
  model: {
    prop: 'value'
  },
  props: {
    value: Boolean,
    highlight: Boolean,
    text: { default: 'Filters', type: String }
  },
  components: {
    CollapseCaret,
    BCollapse
  },
  data() {
    return {}
  },
  computed: {},
  methods: {},
  mounted() {}
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';

.capsule {
  border-radius: 20px;
  padding: 4px 15px 4px 8px;
  border: 1px solid $borderPrimary;
  &.highlight {
    border: 1px solid $borderTertiary;
  }
}
.wrapper.expanded {
  border: 1px solid $borderPrimary;
  border-radius: 10px;
  .capsule {
    border: none;
  }
}
.expandable-section {
  padding: 10px 16px 16px 16px;
}
</style>
